export default "__VITE_ASSET__911cc821__"